

<div fxLayout="row" fxLayoutAlign="space-between center" class="p-2" class="search">
    <div fxLayout="row">
        <button  mat-icon-button  color="primary" matTooltip="Affichage en Grille" (click)="changeViewType('grid')">
            <span><mat-icon>grid_view</mat-icon></span>
        </button>
        <button  mat-icon-button  color="primary" matTooltip="Affichage en Liste" (click)="changeViewType('list')">
            <span><mat-icon>format_list_bulleted</mat-icon></span>
        </button>
        <mat-button-toggle-group #controls="matButtonToggleGroup" appearance="legacy">            

            <mat-button-toggle value="search">
                <mat-icon>search</mat-icon>
            </mat-button-toggle>           
        </mat-button-toggle-group>            
    </div>
    <form class="user-search" [class.show]="controls.value == 'search'">
        <mat-form-field class="user-search-input">
            <input matInput placeholder="Recherche un litige..." (keyup)="applyFilter($event)" name="search">
        </mat-form-field>
    </form>
</div>

<div class="table-wrapper" *ngIf="viewType==='list'"> 
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" id="demo-table">

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
            <td mat-cell *matCellDef="let car; let i = index;">{{i+1}} </td>
        </ng-container>
        <ng-container matColumnDef="marque">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Marque </th>
            <td mat-cell *matCellDef="let car">{{car.vehicle_mark}}</td>
        </ng-container>
        <ng-container matColumnDef="model">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Model </th>
            <td mat-cell *matCellDef="let car">{{car.vehicle_model}} </td>
        </ng-container>


        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
            <td mat-cell *matCellDef="let car">{{car.created_at}} </td>
        </ng-container>


        <ng-container matColumnDef="desc" id="styleColundescript">
            
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description</th>
            <td mat-cell *matCellDef="let car" ><p id="styledescript">{{car.desc_litige}}</p> </td>
           
        </ng-container>

        <ng-container matColumnDef="status" id="styleColundescript">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut</th>
            <td mat-cell *matCellDef="let litige" >
                <button mat-button [matMenuTriggerFor]="menu">{{litige.status}} <mat-icon>expand_more</mat-icon> </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="changeStatus(litige.id,'Enregistré')" disabled="true">Enregistrer</button>
                    <button mat-menu-item (click)="changeStatus(litige.id,'Cloturé')" [disabled]="litige.status=='Cloturé' || litige.status=='Annulé'">Cloturer</button>
                    <button mat-menu-item (click)="changeStatus(litige.id,'Annulé')" [disabled]="litige.status=='Cloturé' || litige.status=='Annulé'">Annuler</button>
                </mat-menu>
            </td>           
        </ng-container>

        <!-- <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> status</th>
            <td mat-cell *matCellDef="let car">{{car.status}} </td>
        </ng-container> -->

        <!-- <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>

            <td mat-cell *matCellDef="let car">
                <button mat-icon-button color="primary" (click)="edit(car.id)" matTooltip="select">
                    Detail
                </button>
            </td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let car; columns: displayedColumns;"></tr>
    </table>
    <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">No data available</p>
</div>


<div fxLayout="row wrap" fxLayoutAlign="center" class="w-100 p-2" *ngIf="viewType==='grid'">
    <mat-card class="menu-item" [fxLayout]="(viewType == 'grid') ? 'column' : 'row'"
        [ngClass]="[viewType + '-item', 'column-'+column]" fxFlex.gt-sm="30" fxFlex.sm="30" *ngFor="let item of resultcat | paginate: { itemsPerPage: 10, currentPage: p }">
        
        <div fxFlex="100" class="p-3">
            <div fxLayout="column" fxLayoutAlign="start stretch" class="h-100">
                <mat-card-content class="mb-0">
                    <div class="grand-title">
                        <mat-icon class="icon-title">taxi_alert</mat-icon>
                        <h1 class="title">{{item.created_at}}</h1>
                    </div>
                    <div>
                        <h1></h1>
                    </div>
                    <div class="mt-2 mb-2"> 
                        <div class="features">
                            <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                <span class="px-1"><mat-icon class="icon-desc">bookmarks</mat-icon> Marque</span>
                                <span class="dots"></span>
                                <span class="fw-500">{{ item.mark_lib}}</span>
                            </p>
                            <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                <span class="px-1"><mat-icon class="icon-desc">time_to_leave</mat-icon> Model</span>
                                <!-- <span class="px-1">Modèle:</span> -->
                                <span class="dots"></span>
                                <span class="fw-500">{{ item.mod_lib }}</span>
                            </p>
                        
                            <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                <span class="px-1"><mat-icon class="icon-desc">today</mat-icon> Date</span>
                                <button mat-button [matMenuTriggerFor]="menu">{{item.status}} <mat-icon>expand_more</mat-icon> </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="changeStatus(item.id,'Enregistré')" disabled="true">Enregistrer</button>
                                    <button mat-menu-item (click)="changeStatus(item.id,'Cloturé')" [disabled]="item.status=='Cloturé' || item.status=='Annulé'">Cloturer</button>
                                    <button mat-menu-item (click)="changeStatus(item.id,'Annulé')" [disabled]="item.status=='Cloturé' || item.status=='Annulé'">Annuler</button>
                                </mat-menu>
                            </p>
                           
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions class="m-0 p-0">
                    <div class="divider mt-1">
                        <div class="text-muted" style="text-align:center">
                            <p >{{item.desc_litige}}</p>
                        </div>
                    </div>
                </mat-card-actions>
            </div>
        </div>
    </mat-card>
    <p *ngIf="resultcat && resultcat.length === 0" class="py-5 mb-0 text-center">No data available</p>
 
</div>

<div fxLayout="row wrap" fxLayoutAlign="space-between" class="w-100 p-2">
    <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20">
        <button  mat-icon-button  color="primary" matTooltip="Rafraichir" (click)="refresh()">
            <span><mat-icon>refresh</mat-icon> Mise à jour</span>
        </button>
    </div>
    
    <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='grid'">
        <pagination-controls (pageChange)="p = $event" style="text-align: end;"></pagination-controls>
    </div>
    <mat-paginator class="{{viewType==='list' ? 'block' : 'hidden'}}"  [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
</div>

